export default __webpack_public_path__ + "static/media/gallery_00.db377fb4.jpg";